import {
  makeStyles,
  shorthands,
  tokens,
  typographyStyles,
} from '@fluentui/react-components';

export const useSuggestionsStyles = makeStyles({
  container: {
    width: '10%',
    display: 'flex',
    rowGap: '40px',
    minWidth: '295px',
    alignSelf: 'stretch',
    flexDirection: 'column',
    ...typographyStyles.body1,
    ...shorthands.overflow('hidden'),
    color: tokens.colorNeutralForeground1,
  },
  panel: {
    display: 'flex',
    alignItems: 'flex-start',
    columnGap: tokens.spacingHorizontalS,

    '& svg': {
      flexShrink: 0,
      marginTop: tokens.spacingVerticalS,
    },
  },
  panelBody: {
    flexWrap: 'wrap',
    rowGap: tokens.spacingVerticalS,
    marginTop: tokens.spacingVerticalS,
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalS,
    marginTop: tokens.spacingVerticalS,
  },
});
